<template>
    <div>
        <hooper :autoPlay="true" :wheelControl="false" :playSpeed="8000" :infiniteScroll="true">
            <slide>
                <div class="container">
                    <div class="row text-center text-white">
                        <div class="col-md-12 mb-5">
                            <img :src="'../img/tendencias.gif'" class="img-fluid mb-5" alt="">
                            <h4 style="font-size: 1.875rem;">1. TENDENCIA A EVOLUCIONAR</h4>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean feugiat pretium nisi, quis pulvinar nulla tincidunt id. Aenean magna mauris, suscipit quis ornare quis, consequat eu arcu.</p>
                        </div>
                    </div>
                </div>
            </slide>
            <slide>
                <div class="container">
                    <div class="row text-center text-white">
                        <div class="col-md-12 mb-5">
                            <img :src="'../img/tendencias.gif'" class="img-fluid mb-5" alt="">
                            <h4 style="font-size: 1.875rem;">2. TENDENCIA A EVOLUCIONAR</h4>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean feugiat pretium nisi, quis pulvinar nulla tincidunt id. Aenean magna mauris, suscipit quis ornare quis, consequat eu arcu.</p>
                        </div>
                    </div>
                </div>
            </slide>
            <slide>
                <div class="container">
                    <div class="row text-center text-white">
                        <div class="col-md-12 mb-5">
                            <img :src="'../img/tendencias.gif'" class="img-fluid mb-5" alt="">
                            <h4 style="font-size: 1.875rem;">3. TENDENCIA A EVOLUCIONAR</h4>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean feugiat pretium nisi, quis pulvinar nulla tincidunt id. Aenean magna mauris, suscipit quis ornare quis, consequat eu arcu.</p>
                        </div>
                    </div>
                </div>
            </slide>
            <hooper-pagination slot="hooper-addons"></hooper-pagination>
        </hooper>
    </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
export default {
    components: {
        Hooper, Slide, HooperPagination, HooperNavigation
    },
    data: () => {
        return {
            currentElement: 0
        }
    }
}
</script>

<style>
:focus {
    border: none;
    outline:none;
}

.hooper {
    height: 100% !important;
}

.hooper-indicator {
    background-color: #fff;
    opacity: 0.25;
}

.hooper-indicator:hover, .hooper-indicator.is-active {
    background-color: #ffffff !important;
    opacity: 1;
}

.evo-slider .hooper-list {
    margin: 46px 0;
}

.evo-slider .hooper-slide .test {
    display: none;
}

.evo-slider .hooper-slide .title {
    padding: 0;
    margin: 10px 0;
}

.evo-slider .hooper-slide .title:after {
    width: 20px;
    height: 2px;
}

.evo-slider .hooper-slide.is-current {
    transform: scale(1.4);
    opacity: 1;
    display: block;
}

.evo-slider .hooper-slide.is-current .title:after {
    display: block;
}


.evo-slider .hooper-slide .title:after {
    display: none;
}

.evo-slider .hooper-slide.is-current .test {
    display: block;
}

.evo-slider .hooper-next {
    right: -40px;
}

.evo-slider .hooper-prev {
    left: -40px;
}

.evo-slider .hooper-next .icon {
    width: 34px;
    height: 34px;
}

.evo-slider .hooper-prev .icon {
    width: 34px;
    height: 34px;
}

.evo-slider .hooper-slide {
    opacity: 0.5;
}

.evo-slider .hooper-track {
    height: auto;
}

@media (max-width: 600px) {
    .evo-slider .hooper-next, .evo-slider .hooper-prev{
        display: none;
    }

    .evo-slider .hooper-list {
        margin: 46px 0;
        height: 336px;
        position: relative;
    }

    .evo-slider .hooper-slide.is-current .test {
        line-height: 18px;
        position: absolute;
        width: 274px;
        height: 100%;
        text-align: center;
        left: -71px;
    }
}
</style>
